// extracted by mini-css-extract-plugin
export default {"zoomControls":"Q_-z","zoomControlButton":"R_-z","zoomBanner":"S_-z","bannerButton":"T_-z","imageButton":"U_-z","zoom":"V_-z","zoomContent":"W_-z"};